// The ?spike=1 probe report (M0 decision 1 / 2, the phone USER GATE: a real device shows `mipmaps` and the
// Phaser capability checks here). A debug surface over the board region, only with ?spike=1 — the M0/M6
// spike shop strip, Beep tab and status chip are gone (M7).
import { signal } from '@preact/signals';
import type { SpikeCheck, SpikeReport } from '../render/Renderer.ts';
import { box } from './components/box.ts';
import { layoutSig } from './state.ts';

export const spikeReportSig = signal<SpikeReport | null>(null);
export const spikePanelSig = signal(false);

function Check({ name, c }: { name: string; c: SpikeCheck }) {
  return (
    <li class={c.ok ? 'ok' : 'bad'}>
      <b>{c.ok ? '✓' : '✗'}</b> {name} <small>{c.note}</small>
    </li>
  );
}

export function SpikePanel() {
  const l = layoutSig.value;
  const r = spikeReportSig.value;
  if (!l || !spikePanelSig.value) return null;
  return (
    <div class="spike-panel ctl" style={box(l.boardRegion)} data-testid="spike-panel">
      {r ? (
        <>
          <div class="spike-head">
            Phaser 4 spike · {r.renderer} · webgl {String(r.webgl)} · mipmaps {String(r.mipmaps)} ·{' '}
            {r.ms} ms
          </div>
          <ul>
            {Object.entries(r.checks).map(([k, c]) => (
              <Check key={k} name={k} c={c} />
            ))}
          </ul>
          <div class="spike-head">
            {r.gl ? `${r.gl.renderer} · max tex ${r.gl.maxTextureSize}` : 'no GL'} · dpr{' '}
            {r.device.dpr} → {r.device.dprEff}
          </div>
        </>
      ) : (
        <div class="spike-head">Running spike… (open with ?spike=1)</div>
      )}
    </div>
  );
}
